module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recent-comments"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h2', [_vm._v("\n        " + _vm._s(_vm.$t('recent_comments.recent_comments')) + "\n        "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })])]), _vm._v(" "), (_vm.comments !== false && _vm.comments.length <= 0) ? _c('div', {
    staticClass: "no-comments"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('recent_comments.no_recent_comments')))])]) : _vm._e(), _vm._v(" "), (_vm.comments === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.comments !== false && _vm.comments.length > 0) ? _c('ul', _vm._l((_vm.comments), function(comment) {
    return _c('comment', {
      key: comment.id,
      attrs: {
        "comment": comment,
        "comment-type": "excerpt",
        "show-avatar": false,
        "show-header": true
      }
    })
  })) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa9c940","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/recent-comments.vue
// module id = 527
// module chunks = 0